<template>
    <div id="pass">
        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :xs="22" :sm="10" :md="8" class="titulo">
                Modificar Contraseña
            </el-col>
        </el-row>
        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :xs="24" :sm="12" :md="10" class="cuerpo">

                <!-- Alertas -->
                <v-alert v-if="caducada" type="error" color="orange" :value="true">
                    Su Contraseña ha expirado. Por favor, ingrese una nueva.
                </v-alert>
                <v-alert v-if="exito" type="success" color="green" :value="true">
                    Su contraseña se ha modificado exitosamente.
                </v-alert>
                <v-alert v-if="error" type="error" color="red" :value="true">
                    Ha ocurrido un error intentanto procesar su solicitud. Por favor, intente nuevamente mas tarde.
                </v-alert>
                <v-alert v-if="incorrecta" type="error" color="red" :value="true">
                    Ha ingresado mal su contraseña. Por favor, intente nuevamente.
                </v-alert>
                <v-alert v-if="tiempo" type="error" color="orange" style="margin-bottom:30px" :value="true">
                    Su Contraseña ya ha sido cambiada en un plazo menor a 24 hs. Intente mañana nuevamente.
                </v-alert>


                <el-form ref="f" :model="f" :rules="rules">
                    <el-form-item label="Contraseña Actual" prop="old">
                        <el-input type="password" ref="Password" v-model="f.old" @paste.prevent @keypress.native="control($event)"></el-input>
                    </el-form-item>
                    <el-form-item label="Nueva Contraseña" prop="password">
                        <el-input type="password" v-model="f.password" @paste.prevent @keypress.native="control($event)"></el-input>
                    </el-form-item>
                    <el-form-item label="Repetir Nueva Contraseña" prop="password2">
                        <el-input type="password" v-model="f.password2" @paste.prevent @keypress.native="control($event)"></el-input>
                    </el-form-item>
                    <el-row :gutter="20" style="margin-top:50px">
                        <el-col :xs="24" :sm="12" style="padding:10px !important; float:right; margin-top:-5px">
                            <v-btn 
                                raised 
                                block
                                color="blue" 
                                :loading="cargando" 
                                @click="submitForm('f')"
                                style="color:#fff"
                            >
                                Guardar Cambios
                            </v-btn>
                        </el-col>
                        <el-col :xs="24" :sm="12" style="padding:10px !important; float:left">
                            <el-button class="el-col el-col-24"                 @click="resetForm('f')" >Cancelar        </el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>


<script>
    import axios from 'axios';

    export default
    {   data()
        {

            /** FUNCIONES DE CONTROL *********************************************************************************/
            var checkVieja = (rule, value, callback) => {
                if (value==this.f.old)
                {   callback(new Error('La Nueva contraseña debe ser diferente a la anterior'));
                }
                else
                {   callback();
                }
            };
            var checkNueva = (rule, value, callback) => {
                if (value!=this.f.password)
                {   callback(new Error('Contraseñas diferentes'));
                }
                else
                {   callback();
                }
            };


            /** RETURN ***********************************************************************************************/
            return {
                cargando:       false,
                exito:          false,
                error:          false,
                incorrecta:     false,
                caducada:       false,
                tiempo:         false,

                f: {
                    old:        '',
                    password:   '',
                    password2:  '',
                },
                rules: {
                    old: [
                        { required: true, message: 'Por favor, ingrese su contraseña actual', trigger: 'blur' },
                        { min: 3, message: 'Mínimo 3 letras', trigger: 'blur' }
                    ],
                    password: [
                        { validator: checkVieja, trigger: 'blur'},
                        { required: true, message: 'Por favor, ingrese su nueva contraseña', trigger: 'blur' },
                        { min: 3, message: 'Mínimo 3 letras', trigger: 'blur' }
                    ],
                    password2: [
                        { validator: checkNueva, trigger: 'blur'},
                        { required: true, message: 'Por favor, repita su nueva contraseña', trigger: 'blur' },
                        { min: 3, message: 'Mínimo 3 letras', trigger: 'blur' }
                    ]
                }
            }
        },


        methods:
        {   control(e)
            {  if( (e.which>32  && e.which<48)  ||
                    (e.which>57  && e.which<65)  ||
                    (e.which>90  && e.which<97)  ||
                    (e.which>123 && e.which<209) ||
                    (e.which>209 && e.which<241) ||
                    (e.which>241)
                )
                { e.preventDefault(); }
            },
            
            submitForm(formName)
            {   this.exito                              = false;
                this.error                              = false;
                this.incorrecta                         = false;
                this.$refs[formName].validate((valid) => {
                    if (valid)
                    {   this.cargando                   = true;
                        var params  = '';
                        var headers = new Headers();
                        headers.append('Content-Type', 'application/x-www-form-urlencoded');

                        params  = params + '&tkn=' + this.$cookies.get('PDTK');
                        params  = params + '&vieja=' + this.f.old;
                        params  = params + '&nueva=' + this.f.password;
                        
                        axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/pss_up.php', params, {headers: headers})
                            .then(response => {
                                const datos                 = response.data;
                                if(datos['mensaje']=='Tiempo')
                                {   this.tiempo             = true;
                                    window.scrollTo(0,0);
                                }
                                else
                                {   if(datos['estado'])
                                    {   this.exito          = true;
                                        this.f.old          = '';
                                        this.f.password     = '';
                                        this.f.password2    = '';
                                        window.scrollTo(0,0);
                                    }
                                    else
                                    {   if(datos['incorrecta'])
                                        {   this.incorrecta = true;  
                                            this.f.old      = ''; 
                                        }
                                        else
                                        {   this.error      = true;
                                        }                                        
                                        window.scrollTo(0,0);
                                    }
                                }
                                this.cargando               = false;
                            })
                            .catch(e => {
                                this.error                  = true;
                            })
                    }
                });
            },
            resetForm(formName)
            {   this.$refs[formName].resetFields();
            }
        },


        beforeMount()
        {   if(!this.$cookies.get('PDTK'))
            {   this.$router.push('../login');
            }
            else
            {   var params  = 'tkn=' + this.$cookies.get('PDTK');
                var headers = new Headers();
                headers.append('Content-Type', 'application/x-www-form-urlencoded');
                
                axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/doc.php', params, {headers: headers})
                    .then(response => {
                        const datos                         = response.data
                        if(datos['clave'])                  this.caducada = true;
                    })
                   /* .catch(e => {})*/
            }
        },


        mounted()
        {   this.$nextTick(this.$refs.Password.focus);
        }
    };
</script>
